import { render, staticRenderFns } from "./PdfIcon.vue?vue&type=template&id=13aa9ae9&"
import script from "./PdfIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PdfIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports